import React from "react";

interface GoalsIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const GoalsIcon: React.FC<GoalsIconProps> = ({
  width = 18,
  height = 18,
  fill = "currentColor",
  className = "",
}) => {
  return (
    <svg
      preserveAspectRatio="none"
      width={width}
      height={height}
      overflow="visible"
      style={{ display: "block" }}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        id="Vector"
        d="M13.1538 9.69231H15.191C15.0321 11.0959 14.4017 12.404 13.4028 13.4028C12.404 14.4017 11.0959 15.032 9.69231 15.191V13.1538C9.69231 12.9702 9.61937 12.7941 9.48954 12.6643C9.3597 12.5345 9.18361 12.4615 9 12.4615C8.81639 12.4615 8.6403 12.5345 8.51047 12.6643C8.38063 12.7941 8.30769 12.9702 8.30769 13.1538V15.191C6.90412 15.032 5.59598 14.4017 4.59717 13.4028C3.59835 12.404 2.96795 11.0959 2.80904 9.69231H4.84616C5.02977 9.69231 5.20586 9.61937 5.33569 9.48953C5.46552 9.3597 5.53846 9.18361 5.53846 9C5.53846 8.81639 5.46552 8.6403 5.33569 8.51046C5.20586 8.38063 5.02977 8.30769 4.84616 8.30769H2.80904C2.96795 6.90412 3.59835 5.59598 4.59717 4.59716C5.59598 3.59834 6.90412 2.96795 8.30769 2.80904V4.84615C8.30769 5.02976 8.38063 5.20586 8.51047 5.33569C8.6403 5.46552 8.81639 5.53846 9 5.53846C9.18361 5.53846 9.3597 5.46552 9.48954 5.33569C9.61937 5.20586 9.69231 5.02976 9.69231 4.84615V2.80904C11.0959 2.96795 12.404 3.59834 13.4028 4.59716C14.4017 5.59598 15.0321 6.90412 15.191 8.30769H13.1538C12.9702 8.30769 12.7941 8.38063 12.6643 8.51046C12.5345 8.6403 12.4615 8.81639 12.4615 9C12.4615 9.18361 12.5345 9.3597 12.6643 9.48953C12.7941 9.61937 12.9702 9.69231 13.1538 9.69231ZM18 9C18 10.78 17.4722 12.5201 16.4832 14.0001C15.4943 15.4802 14.0887 16.6337 12.4442 17.3149C10.7996 17.9961 8.99002 18.1743 7.24419 17.8271C5.49836 17.4798 3.89471 16.6226 2.63604 15.364C1.37737 14.1053 0.520203 12.5016 0.172937 10.7558C-0.17433 9.00998 0.00389956 7.20038 0.685088 5.55585C1.36628 3.91131 2.51983 2.50571 3.99987 1.51677C5.47991 0.527841 7.21997 0 9 0C11.3862 0.00251984 13.6739 0.95154 15.3612 2.63882C17.0485 4.3261 17.9975 6.61382 18 9ZM16.6154 9C16.6154 7.49382 16.1688 6.02146 15.332 4.76912C14.4952 3.51677 13.3058 2.54069 11.9143 1.9643C10.5228 1.38791 8.99155 1.2371 7.51431 1.53094C6.03708 1.82478 4.68014 2.55008 3.61511 3.61511C2.55008 4.68014 1.82479 6.03707 1.53095 7.51431C1.23711 8.99155 1.38792 10.5228 1.96431 11.9143C2.5407 13.3058 3.51678 14.4952 4.76912 15.332C6.02146 16.1687 7.49382 16.6154 9 16.6154C11.019 16.6131 12.9547 15.81 14.3824 14.3824C15.81 12.9547 16.6131 11.019 16.6154 9Z"
        fill={fill}
      />
    </svg>
  );
};

export default GoalsIcon;
